// Main Vue.js application entry point
import './vue-app.js';
import './components/index.js';

// Initialize Vue components when DOM is ready
// Use both DOMContentLoaded and jQuery ready to ensure compatibility
document.addEventListener('DOMContentLoaded', function() {
    initializeVue();
});

// Also initialize when jQuery is ready (for compatibility with existing code)
if (typeof $ !== 'undefined') {
    $(document).ready(function() {
        initializeVue();
    });
} else {
    // If jQuery is not available yet, wait a bit and try again
    setTimeout(() => {
        if (typeof $ !== 'undefined') {
            $(document).ready(function() {
                initializeVue();
            });
        }
    }, 100);
}

function initializeVue() {
    // Prevent double initialization
    if (window.vueInitialized) {
        return;
    }

    // Initialize Vue components
    if (window.initializeVueComponents) {
        window.initializeVueComponents();
        window.vueInitialized = true;
        console.log('Vue.js application initialized');
    } else {
        console.warn('Vue initialization functions not available');
    }
}
